import { EventrDate } from "@eventr/common";
import { ColoursObj, Typography, getContrastYIQ } from "@eventr/common-storybook";
import { Box } from "@mui/material";
import { useLanguageContext } from "state/languageState/languageContext";
import { useShallow } from "zustand/react/shallow";
import { CarouselItineraryTags } from "./slide/newComps/itineraryTags";
export function ItineraryDateWindow({
  id,
  start,
  end,
  tags,
}: {
  id?: string;
  start?: string;
  end?: string;
  tags?: number[];
}) {
  const { getLanguageISO639Code } = useLanguageContext(
    useShallow((s) => {
      return {
        getLanguageISO639Code: s.getLanguageISO639Code,
      };
    }),
  );

  // Ensure the start and end dates are valid.
  if (!start || !end) return null;

  const parsedStart = new EventrDate(start);
  const parsedEnd = new EventrDate(end);

  const styledStart = parsedStart.toItinLocalStyledShortDateString(getLanguageISO639Code());
  const styledEnd = parsedEnd.toItinLocalStyledShortDateString(getLanguageISO639Code());

  // Ensure the start and end dates are styled appropriately.
  if (styledStart === "" || styledEnd === "") return null;

  const isSameDate = styledStart === styledEnd;

  return (
    <Box
      sx={{
        display: "grid",
        justifyItems: "center",
        gap: "4px"
      }}>
      <Box
        sx={{
          display: "grid",
          gridAutoFlow: "column",
          gap: "8px",
          alignItems: "center",
          width: "max-content"
        }}>
        <StyledDate id={`${id}itinerary-date-range-start-date-styled`} styledDate={styledStart} />
        {!isSameDate && (
          <>
            <Box
              sx={{
                height: "1px",
                width: "6px",
                backgroundColor: getContrastYIQ(ColoursObj.backgrounds.header),
              }}
            />
            <StyledDate id={`${id}itinerary-date-range-end-date-styled`} styledDate={styledEnd} />
          </>
        )}
      </Box>
      <Box>
        <CarouselItineraryTags id={`${id}itinerary-tags`} tags={tags || []} />
      </Box>
    </Box>
  );
}

const StyledDate = ({ id, styledDate }: { id: string; styledDate: string }) => {
  return (
    <Typography
      id={id}
      variant="bodySubtext"
      align="center"
      color={getContrastYIQ(ColoursObj.backgrounds.header)}
      style={{
        transition: "0.5s",
      }}
    >
      {styledDate}
    </Typography>
  );
};
